import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintenanceOverlayComponent } from './maintenance-overlay.component';
import { MaintenanceOverlayService } from './maintenance-overlay.service';
import { GenericModalService } from '@draeger-academy/presentation/lib/modules/generic-modal';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [MaintenanceOverlayComponent],
    imports: [CommonModule, TranslateModule.forChild()],
    exports: [MaintenanceOverlayComponent],
    providers: [MaintenanceOverlayService, GenericModalService]
})
export class MaintenanceOverlayModule {}
